import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// @material-ui/core components
import {
  Grid,
  TableRow,
  Icon,
  IconButton,
  Tooltip,
  TableCell,
  TableBody,
  TableHead,
  Table,
  Button,
  Checkbox,
} from "@material-ui/core";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import tableStyles from "../../../../../assets/jss/components/tableStyle";
import styles from "../../../../../assets/jss/layouts/appStyle";
// core components
import { LOCALE } from "../../../../../properties/Locale";
import Card from "../../../../../common/components/Card/Card.js";
import CardHeader from "../../../../../common/components/Card/CardHeader.js";
import CardBody from "../../../../../common/components/Card/CardBody.js";
import { TrainingOrganizerRepository } from "./TrainingOrganizerRepository";

const useStyles = makeStyles(styles, tableStyles);

export default function TrainingOrganizerComponent(props) {
  const classes = useStyles();
  const [data, setData] = useState();
  const globalState = useSelector((state) => state);

  useEffect(() => {
    loadOrganizer();
  }, [globalState.triggerRerender]);

  const loadOrganizer = () => {
    TrainingOrganizerRepository.fetchAll(props.gradingSchemaId)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {});
  };

  return (
    <Grid item md={12} style={{ paddingTop: "25px" }}>
      <Card>
        <CardHeader color="theme">
          <Tooltip
            title={LOCALE.create_new_training_organizer}
            aria-label={LOCALE.create_new_training_organizer}
            arrow
            placement={"bottom"}
          >
            <Link
              to={`/app/configuration/gradingSchema/${props.gradingSchemaId}/edit/trainingOrganizer/create`}
              style={{ textDecoration: "none" }}
            >
              <Button
                color="primary"
                variant="contained"
                startIcon={<Icon>add_circle_outline</Icon>}
                size="small"
                aria-label="create"
              >
                {LOCALE.create_new_training_organizer}
              </Button>
            </Link>
          </Tooltip>
        </CardHeader>
        <CardBody>
          <Table aria-label="groups table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.name}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.active}
                </TableCell>
                <TableCell
                  style={{ marginBottom: "62px", minWidth: "200px" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.date_created}
                </TableCell>
                <TableCell
                  style={{ marginBottom: "62px", minWidth: "90px" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((organizer, index) => (
                <TableRow
                  key={organizer.id}
                  className={classes.tableBodyRow}
                  style={index % 2 ? { background: "#f0f0f0" } : {}}
                >
                  <TableCell className={classes.tableCell}>
                    {organizer.name}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <Checkbox
                      checked={organizer.active ? true : false}
                      disabled
                      inputProps={{ "aria-label": "primary checkbox" }}
                    ></Checkbox>
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {moment(organizer.dateCreated).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}{" "}
                    ({moment(organizer.dateCreated).fromNow()})
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <Tooltip title={LOCALE.details} aria-label={LOCALE.details}>
                      <Link
                        to={`/app/configuration/gradingSchema/${props.gradingSchemaId}/edit/trainingOrganizer/${organizer.id}/details`}
                        style={{ textDecoration: "none" }}
                      >
                        <IconButton
                          size="small"
                          color="primary"
                          aria-label="details"
                        >
                          <Icon>ballot</Icon>
                        </IconButton>
                      </Link>
                    </Tooltip>
                    <Tooltip title={LOCALE.edit} aria-label={LOCALE.edit}>
                      <Link
                        to={`/app/configuration/gradingSchema/${props.gradingSchemaId}/edit/trainingOrganizer/${organizer.id}/edit`}
                        style={{ textDecoration: "none" }}
                      >
                        <IconButton
                          size="small"
                          style={{ color: "orange" }}
                          aria-label="edit"
                        >
                          <Icon>edit</Icon>
                        </IconButton>
                      </Link>
                    </Tooltip>
                    <Tooltip title={LOCALE.delete} aria-label={LOCALE.delete}>
                      <Link
                        to={`/app/configuration/gradingSchema/${props.gradingSchemaId}/edit/trainingOrganizer/${organizer.id}/delete`}
                        style={{ textDecoration: "none" }}
                      >
                        <IconButton
                          color="secondary"
                          size="small"
                          aria-label="delete"
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                      </Link>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
    </Grid>
  );
}
